var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      domProps: { innerHTML: _vm._s(_vm.$t("disabilities_description")) },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.disabilities, function (disability, idx) {
        return _c("div", { key: idx, staticClass: "col-md-12" }, [
          _c(
            "fieldset",
            { staticClass: "well" },
            [
              _c("legend", [
                _c("span", [_vm._v("Rodzaj niepełnosprawności")]),
                _vm._v(" "),
                idx > 0 || _vm.disabilities.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger pull-right",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeDisability(idx)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "glyphicon glyphicon-remove" }, [
                          _vm._v("x"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Usuń niepełnosprawność"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-5" },
                  [
                    _c(
                      "ic-form-row",
                      {
                        attrs: {
                          aria: "Pole jest wymagane",
                          label: "Rodzaj niepełnosprawności",
                          new_id: "type" + idx,
                          error: _vm.hasError(
                            "form.disabilities[" + idx + "].type"
                          ),
                          required: _vm.isRequired(
                            "form.disabilities[" + idx + "].type"
                          ),
                        },
                      },
                      [
                        _c("ic-select-system", {
                          attrs: {
                            id: "type" + idx,
                            values: _vm.disabilityTypes,
                            v: _vm.v.form.disabilities.$each[idx].type,
                            placeholder:
                              "... (Wybierz jedną z " +
                              _vm.disabilityTypes.length +
                              " opcji)",
                          },
                          on: {
                            "update:select": function ($event) {
                              return _vm.onUpdateDisability(idx)
                            },
                          },
                          model: {
                            value: disability.type,
                            callback: function ($$v) {
                              _vm.$set(disability, "type", $$v)
                            },
                            expression: "disability.type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                disability.type || disability.persons
                  ? _c(
                      "div",
                      { staticClass: "col-sm-2 col-xs-4" },
                      [
                        _c(
                          "ic-form-row",
                          {
                            attrs: {
                              aria: "Pole jest wymagane",
                              label: "Liczba osób",
                              new_id: "persons" + idx,
                              error: _vm.hasError(
                                "form.disabilities[" + idx + "].persons"
                              ),
                              required: _vm.isRequired(
                                "form.disabilities[" + idx + "].persons"
                              ),
                            },
                          },
                          [
                            _c("ic-input", {
                              attrs: {
                                id: "persons" + idx,
                                type: "number",
                                v: _vm.v.form.disabilities.$each[idx].persons,
                              },
                              model: {
                                value: disability.persons,
                                callback: function ($$v) {
                                  _vm.$set(disability, "persons", $$v)
                                },
                                expression: "disability.persons",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                disability.type || disability.persons
                  ? _c(
                      "div",
                      { staticClass: "col-sm-5 col-xs-8 form-padding-left" },
                      [
                        _c(
                          "ic-form-row",
                          {
                            attrs: {
                              aria: "Pole jest wymagane",
                              label: "Rodzaj zaopatrzenia ortopedycznego",
                              new_id: "equipment" + idx,
                              error: _vm.hasError(
                                "form.disabilities[" + idx + "].equipment"
                              ),
                              required: _vm.isRequired(
                                "form.disabilities[" + idx + "].equipment"
                              ),
                            },
                          },
                          [
                            _c("ic-checkbox-group", {
                              attrs: {
                                id: "equipment" + idx,
                                options: _vm.equipmentTypes[idx],
                                v: _vm.v.form.disabilities.$each[idx].equipment,
                              },
                              on: {
                                "update:select": function ($event) {
                                  return _vm.onUpdateEquipment(idx)
                                },
                              },
                              model: {
                                value: disability.equipment,
                                callback: function ($$v) {
                                  _vm.$set(disability, "equipment", $$v)
                                },
                                expression: "disability.equipment",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.hasWheelchair(idx)
                ? _c(
                    "ic-form-row",
                    {
                      attrs: {
                        new_id: "size",
                        error: _vm.hasError(
                          "form.disabilities[" + idx + "].size"
                        ),
                      },
                    },
                    [
                      !disability.size
                        ? _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("disabilities_size_description"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ic-checkbox",
                        {
                          attrs: {
                            id: "size" + idx,
                            aria: "Pole jest wymagane",
                            val: 1,
                            v: _vm.v.form.disabilities.$each[idx].size,
                          },
                          model: {
                            value: disability.size,
                            callback: function ($$v) {
                              _vm.$set(disability, "size", $$v)
                            },
                            expression: "disability.size",
                          },
                        },
                        [
                          _vm._v(
                            "Oświadczam, że wózek inwalidzki nie przekracza granicznych wymiarów i wagi *"
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasWheelchair(idx)
                ? _c("ic-form-row", { attrs: { id: "sizePicture" } }, [
                    _c("img", {
                      staticClass: "img-responsive",
                      staticStyle: {
                        "max-width": "500px",
                        display: "block",
                        margin: "20px auto",
                      },
                      attrs: {
                        src: "img/wymiary_wozka.png",
                        alt: "Rysunek z podanymi wymiarami granicznymi wózka inwalidzkiego, dopuszczonego do przewozu koleją",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Graniczne parametry konstrukcyjne wózka inwalidzkiego przystosowanego do przewozu koleją są następujące:"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "szerokość 700 mm powiększona o co najmniej 50 mm z każdej strony na ręce podczas przemieszczania się;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "długość 1 200 mm powiększona o 50 mm na stopy;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "koła — najmniejsze koło musi być w stanie pokonać szczelinę o szerokości 75 mm w poziomie i różnicę wysokości 50 mm;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "wysokość — maksimum 1 375 mm wraz z użytkownikiem płci męskiej;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [_vm._v("łuk skrętu — 1 500 mm;")]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "masa przy pełnym obciążeniu wózka z użytkownikiem (oraz z ewentualnym bagażem) wynosząca 300 kg w przypadku elektrycznego wózka inwalidzkiego, dla którego nie jest wymagana pomoc w celu przejechania przez urządzenie wspomagające wsiadanie;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "w przypadku gdy jest wymagana pomoc w celu przejechania przez urządzenie wspomagające wsiadanie masa taka wynosi 300 kg (do takiej masy są przystosowane rampy);"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "masa przy pełnym obciążeniu wózka z użytkownikiem (oraz z ewentualnym bagażem) wynosząca 200 kg w przypadku ręcznego wózka inwalidzkiego."
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              disability.type == "other" ||
              disability.equipment.indexOf("other") > -1
                ? _c(
                    "ic-form-row",
                    {
                      attrs: {
                        label: "Uwagi",
                        new_id: "remarks" + idx,
                        error: _vm.hasError(
                          "form.disabilities[" + idx + "].remarks"
                        ),
                        required: _vm.isRequired(
                          "form.disabilities[" + idx + "].remarks"
                        ),
                      },
                    },
                    [
                      _c("ic-textarea", {
                        attrs: {
                          id: "remarks" + idx,
                          v: _vm.v.form.disabilities.$each[idx].remarks,
                        },
                        model: {
                          value: disability.remarks,
                          callback: function ($$v) {
                            _vm.$set(disability, "remarks", $$v)
                          },
                          expression: "disability.remarks",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    this.disabilities.length < 6
      ? _c(
          "button",
          {
            staticClass: "btn btn-toggle btn-block btn-secondary mt-3",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.addDisability.apply(null, arguments)
              },
            },
          },
          [_vm._v("Dodaj rodzaj niepełnosprawności")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }